module.exports = __webpack_public_path__ + "img/logo_titulo_invert.b1406ac1.svg";